import logo from "./logo.svg";
import "./App.css";
import {
  BrowserRouter,
  HashRouter,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import SideBar from "./Component/SideBar";
import Dashbord from "./Component/Dashbord/Dashbord";
import { useEffect, useState } from "react";
import Content from "./Component/Content";
import InfoPhones from "./Component/InfoPhones/InfoPhones";
import User from "./Component/User/User";
import Login from "./Component/Login/Login";
import "react-notifications/lib/notifications.css";
import axios from "axios";
import { io } from "socket.io-client";
import NotFound from "./Component/404/NotFound";
import ProtectedRoute from "./Component/utils/ProtectedRoute";
import PrivateRoute from "./Component/utils/PrivateRoute";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import Cmd from "./Component/cmd/Cmd";
import Report from "./Component/Report/Report";
function App() {
  const [bar, setbar] = useState(true);
  const BaseUrl = "http://urmianews.com:8443";
  // const BaseUrl = "http://192.168.1.102:5003";
  const [gate, setgate] = useState({});
  const TOKEN = localStorage.getItem("TOKEN");
  const Handeler_menu = () => {
    setbar(!bar);
    console.log(bar, "bar");
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("TOKEN")}`,
    withCredentials: true,
  };

  useEffect(() => {
    return () => {
      window.addEventListener("beforeunload", function (e) {
        this.localStorage.removeItem("TOKEN");
      });
    };
  });

  return (
    <div className="w-full ">
      <HashRouter>
        <Routes>
          <Route path={"/login"} element={<Login BaseUrl={BaseUrl} />} />
          <Route
            element={
              <SideBar
                bar={bar}
                BaseUrl={BaseUrl}
                Handeler_menu={Handeler_menu}
              />
            }
          >
            <Route exact path="/" element={<PrivateRoute BaseUrl={BaseUrl} />}>
              <Route
                index
                path={"/"}
                element={<Dashbord bar={bar} BaseUrl={BaseUrl} />}
              />
              <Route
                path={"/InfoPhones"}
                element={<InfoPhones bar={bar} BaseUrl={BaseUrl} />}
              />
              <Route
                path={"/cmd"}
                element={<Cmd bar={bar} BaseUrl={BaseUrl} />}
              />

              <Route
                path={"/report"}
                element={<Report bar={bar} BaseUrl={BaseUrl} />}
              />

              <Route
                path={"/user"}
                element={
                  <ProtectedRoute BaseUrl={BaseUrl}>
                    <User bar={bar} BaseUrl={BaseUrl} />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Route>
          <Route path="*" element={<NotFound BaseUrl={BaseUrl} />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
